module.exports = __webpack_public_path__ + "assets/img/logo_mobile.0554c53b.png";